import React from 'react';
export function PasswordChangedTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-525">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-526">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-527" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-528">
        <div style={{
        textAlign: 'center',
        marginBottom: '24px'
      }} data-id="element-529">
          <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '64px',
          height: '64px',
          backgroundColor: '#dbeafe',
          borderRadius: '50%',
          marginBottom: '16px'
        }} data-id="element-530">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-531">
              <polyline points="20 6 9 17 4 12" data-id="element-532"></polyline>
            </svg>
          </div>
        </div>

        <h1 style={{
        fontSize: '24px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '16px',
        marginTop: '0',
        textAlign: 'center'
      }} data-id="element-533">
          Password updated
        </h1>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px',
        textAlign: 'center'
      }} data-id="element-534">
          Your password has been successfully changed.
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-535">
          Your Aisco Workspace password has been updated successfully. You can
          now log in with your new password.
        </p>

        <div style={{
        backgroundColor: '#eff6ff',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '32px'
      }} data-id="element-536">
          <p style={{
          fontSize: '14px',
          color: '#1e40af',
          lineHeight: '1.6',
          margin: '0'
        }} data-id="element-537">
            <strong data-id="element-538">Security tip:</strong> Make sure to use a unique and secure
            password that you don't use for other services.
          </p>
        </div>

        {/* CTA Button */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-539">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600'
        }} data-id="element-540">
            Log in
          </a>
        </div>

        <div style={{
        backgroundColor: '#fee2e2',
        padding: '16px',
        borderRadius: '8px',
        borderLeft: '4px solid #dc2626',
        marginTop: '32px'
      }} data-id="element-541">
          <p style={{
          fontSize: '14px',
          color: '#991b1b',
          lineHeight: '1.6',
          margin: '0'
        }} data-id="element-542">
            <strong data-id="element-543">Wasn't you?</strong> If you didn't request this change,
            please contact our support team immediately.
          </p>
        </div>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-544">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-545">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-546" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}